module.exports = __webpack_public_path__ + "img/close.04582cda.svg";